<template>
  <div class="wrap">
    <div class="wrapContent">

      <div class="info">
        <!-- 交易状态 -->
        <div class="state">
          <p class="fail" v-if="details.trade_status == 6">
            <span>
              <i class="iconfont icon-delete_s"></i>
            </span>
            {{pc_lang.Transaction_failed}} {{ !!details.remarks ? ` - ${details.remarks}` : '' }}
          </p>
          <p class="success" v-else>
            <span>
              <i class="iconfont icon-shiliangzhinengduixiang"></i>
            </span>
            {{pc_lang.Successful_transaction}}
          </p>
        </div>
        <!-- 交易内容 -->
        <div class="content">
          <div class="formContent">

            <div class="table_1">
              <table>
                <caption>{{details.trade_notes}}</caption>
                <tbody>
                  <tr>
                    <td>{{pc_lang.transaction_currency}}</td>
                    <td>{{details.actual_currency_short}}</td>
                    <td>{{pc_lang.Amount}}({{details.currency_short}})</td>
                    <td>{{pc_lang.Processing_fee}}</td>
                    <td>{{pc_lang.Total_paid}}({{details.actual_currency_short}})</td>
                  </tr>
                  <tr>
                    <td>{{pc_lang.Transaction_number}}</td>
                    <td>{{details.trade_serial_no}}</td>
                    <td>{{details.amount}}</td>
                    <td>{{details.service_amount || '0.00'}}</td>
                    <td>{{details.actual_amount}}</td>
                  </tr>
                  <tr>
                    <td>{{pc_lang.Merchant_order_number}}</td>
                    <td colspan="4">{{details.mch_order_no}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table_2">
              <table>
                <tbody>
                  <tr>
                    <td>{{pc_lang.Counterparty_information}}</td>
                    <td>{{details.company_name}}</td>
                    <td>{{pc_lang.Creation_time}}</td>
                    <td>{{pc_lang.Payment_time}}</td>
                    <td>{{pc_lang.End_Time}}</td>
                  </tr>
                  <tr>
                    <td>{{pc_lang.Merchant_description}}</td>
                    <td>{{details.trade_notes}}</td>
                    <td>{{details.creation_time}}</td>
                    <td>{{details.payment_time}}</td>
                    <td>{{details.end_time}}</td>
                  </tr>
                  <tr>
                    <td>{{pc_lang.Merchant_name}}</td>
                    <td colspan="4">{{details.shop_name}}</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>

      <div v-if="!!details.bill_no">
        <el-button type="primary" size="small" @click="showBill(details)">{{ pc_lang['View_the_bill'] }}</el-button>
      </div>

      <el-dialog :title="pc_lang['Bill']" width="1100px" height="400px" :visible.sync="dialogIframeVisible" :append-to-body="true" @close="iframeClose">
        <iframe :src="iframeSrc" frameborder="0" width="1070" height="400"></iframe>
      </el-dialog>

      <!-- 快问快答 -->
      <div class="FAQ" v-if="FAQ.trade">
        <h5>FAQ</h5>
        <template v-for="(item, i) in FAQ.trade">
          <div>{{item.title}}</div>
          <p>{{item.content}}</p>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import { Button, Dialog } from 'element-ui'
Vue.use(Button).use(Dialog)
import API from '@/utils/api'
import * as API_PAY from '@/api/pay'
import { mapGetters } from 'vuex'

export default {
  name: 'TradeDetails',
  components: {

  },
  data() {
    return {
      trade_serial_no: '',
      details: {

      },
      dialogIframeVisible: false,
      iframeSrc: ''
    }
  },
  computed: {
    ...mapGetters(['FAQ'])
  },
  async mounted() {

  },
  created() {
    this.trade_serial_no = this.$route.query.trade_serial_no
    this.getDealDetails()
  },
  methods: {
    /* 获取详情 */
    getDealDetails() {
      let param = {
        trade_serial_no: this.trade_serial_no
      }
      API_PAY.dealDetails(param).then(res=> {
        this.details = res.data
      },rej=> {

      })
    },
    /* 查看票据 */
    showBill(item) {
      // this.iframeSrc = `${API.admin}/bill/info?type=0&trade_id=${item.trade_id}&user_id=${item.user_id}`
      this.iframeSrc = `${API.admin}/trade/trade_record/pj/${item.trade_serial_no}`
      this.dialogIframeVisible = true
    },
    iframeClose() {
      this.iframeSrc = ``
    }
  }
}
</script>
<style lang="scss" scoped>

.wrapContent{
  background: #fff;
  margin: 20px auto 40px;
  padding: 20px 40px;
  .info{
    .state{
      p{
        padding: 35px 0 15px;
        font-size: 24px;
        &.success{
          color: $blue;
          span{
            background: $blue;
          }
        }
        &.fail{
          color: $red_xi;
          span{
            background: $red_xi;
          }
        }
      }
      span{
        display: inline-flex;
        width: 34px;
        height: 34px;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        i{
          font-size: 24px;
          height: 24px;
          color: #fff;
          display: inline-block;
        }
      }
    }
    .content{
      margin: 0 auto;
      .formContent{
        >div{
          padding: 10px 0;
        }
        .table_1{
          border-bottom: $border;
        }
        table{
          caption{
            text-align: left;
            padding: 5px 10px;
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
          }
          tr{
            &:nth-child(1){
              td{
                color: #555;
                font-weight: 600;
              }
            }
          }
          td{
            padding: 8px 10px;
            color: #999;
            &:nth-child(1){
              word-break: break-all;
              width: 120px;
              color: #555;
              font-weight: 600;
            }
            &:nth-child(3), &:nth-child(4), &:nth-child(5){
              width: 190px;
            }
          }
        }
      }
    }
  }
}
</style>